(function() {

    let handleFormInput = function(filtersForm) {
        const collectionUrl = filtersForm.dataset.collectionUrl;
        //const sectionId = document.querySelector('#MainCollectionProductGrid').closest('.shopify-section').id;
        const sectionId = 'main-collection-product-grid';

        $(".collection-filter-head").click();

        console.log('collectionUrl 1',filtersForm,collectionUrl)

        let tags = [];
        filtersForm.querySelectorAll('input[type="checkbox"]').forEach((item) => {
            if(item.checked) {
                tags.push(item.getAttribute('name'));
            }
        });

        let url = collectionUrl + (tags.length > 0 ? ('/' + tags.join('+')) : '') + '?section_id=' + sectionId + (window.location.search ? ('&' + window.location.search) : '');
        if(tags.length == 1){
          // url = collectionUrl + (tags.length > 0 ? ('?tags=' + tags.join('+')) : '') + '?section_id=' + sectionId + (window.location.search ? ('&' + window.location.search) : '');
        }
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                document.getElementById('MainCollectionProductGrid').innerHTML = new DOMParser()
                    .parseFromString(html, 'text/html')
                    .getElementById('MainCollectionProductGrid').innerHTML;

                if(window.setupProductCards) {
                    window.setupProductCards();
                }

                setupFilterResetButton();
            });
        window.history.replaceState(null, null, `https://${window.location.host}${(collectionUrl + (tags.length > 0 ? ('/' + tags.join('+')) : '') + (window.location.search ? ('&' + window.location.search) : ''))}`);
    }

    document.querySelectorAll('form.header-top-filters').forEach((filtersForm) => {
        let debounceOnSubmit = debounce((event) => {
            handleFormInput(filtersForm);
        }, 500);
        let onInput = function(event) {
            const targetName = event.target.getAttribute('name');
            const checked = event.target.checked;
            document.querySelectorAll('input[name="'+targetName+'"]').forEach((input) => {
                if(input.checked != checked) {
                    input.checked = checked;
                }
            });
            debounceOnSubmit(event);
        }

        filtersForm.addEventListener('input', onInput);
    });


  // document.addEventListener('DOMContentLoaded', function() {
    // Check if any input is checked
    var checkedInputs = document.querySelectorAll('.header-top-collection .product-style .dropdown input:checked');
    if (checkedInputs.length > 0) {
        var dropdowns = document.querySelectorAll('.header-top-collection .product-style .dropdown');
        dropdowns.forEach(function(dropdown) {
            var inputs = dropdown.querySelectorAll('input:not(:checked)');
            inputs.forEach(function(input) {
                input.disabled = true; // Disable unchecked inputs
            });
        });
    }

    var checkedColorInputs = document.querySelectorAll('.header-top-collection .product-color .dropdown input:checked');
    if (checkedColorInputs.length > 0) {
        var dropdowns = document.querySelectorAll('.header-top-collection .product-color .dropdown');
        dropdowns.forEach(function(dropdown) {
            var inputs = dropdown.querySelectorAll('input:not(:checked)');
            inputs.forEach(function(input) {
                input.disabled = true; // Disable unchecked inputs
            });
        });
    }

    // Add change event listener to all inputs
    var allInputs = document.querySelectorAll('.header-top-collection .product-style .dropdown input');
    allInputs.forEach(function(input) {
        input.addEventListener('change', function() {
            var currentName = this.name;

            if (this.checked) {
                // Disable all other inputs in the same dropdown
                var otherInputs = this.closest('.dropdown').querySelectorAll('input:not([name="' + currentName + '"])');
                otherInputs.forEach(function(otherInput) {
                    otherInput.disabled = true;
                });
            } else {
                // Enable all inputs in the dropdown when the current input is unchecked
                var allDropdownInputs = this.closest('.dropdown').querySelectorAll('input');
                allDropdownInputs.forEach(function(allInput) {
                    allInput.disabled = false;
                });
            }
        });
    });

    var allColorInputs = document.querySelectorAll('.header-top-collection .product-color .dropdown input');
    allColorInputs.forEach(function(input) {
        input.addEventListener('change', function() {
            var currentName = this.name;

            if (this.checked) {
                // Disable all other inputs in the same dropdown
                var otherColorInputs = this.closest('.dropdown').querySelectorAll('input:not([name="' + currentName + '"])');
                otherColorInputs.forEach(function(otherInput) {
                    otherInput.disabled = true;
                });
            } else {
                // Enable all inputs in the dropdown when the current input is unchecked
                var allDropdownInputs = this.closest('.dropdown').querySelectorAll('input');
                allDropdownInputs.forEach(function(allInput) {
                    allInput.disabled = false;
                });
            }
        });
    });
// });
  
    const setupFilterResetButton = function() {
        document.querySelectorAll('.filter-reset-button').forEach((button) => {
            button.addEventListener('click', function() {
                let parentForm = button.closest('form');
                if(!parentForm) {
                    parentForm = document.querySelectorAll('form.header-top-filters')[0];
                }
                document.querySelectorAll('form.header-top-filters').forEach((form) => {
                    form.querySelectorAll('input[type="checkbox"]').forEach((item) => {
                        item.checked = false;
                    });
                });
                if(!parentForm) return;
                handleFormInput(parentForm);
            });
        });
    };

    setupFilterResetButton();
})();